import React, { useState, useRef, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import { Col, Button, FormGroup, Label, Row } from "reactstrap";
import CoveredEntity from "components/CoveredEntity";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useAxios from "hooks/useAxios";
import { cloneDeep } from "lodash";
import NPIProviderList from "components/NPIProviderList";
import PatientList from "components/PatientList";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";

// const validationSchema = Yup.object({
//   coveredEntityName: Yup.string().required("Please select covered entity"),
// });

const SearchContainer = ({
  filterBySearch,
  handleUpdateEntity,
  onSearch,
  onReset,
  selectedCEId,
  orgId,
}) => {
  const API = useAxios();
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [error, setError] = useState(false)

  const [state, updateState] = useState({
    selectedCoveredEntity: {},
    selectedProvider: null,
    selectedPatient: null,
    direction:
      selectedCEId !== ""
        ? window.selectedFaxDirection !== ""
          ? window.selectedFaxDirection
          : "190001"
        : "",
    directionOptions: [],
    faxstatus:
      selectedCEId !== ""
        ? window.selectedFaxStatus !== ""
          ? window.selectedFaxStatus
          : "180004"
        : "",
    faxStatusOption: [],
    loading: false,
  });

  const formikRef = useRef();

  useEffect(() => {
    setState({ loading: true });
    fetchDirections();
    fetchFaxStatus();

  }, []);

  useEffect(() => {
    setSelectedCE("")
    setError(false)
  }, [orgId])

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const fetchDirections = async () => {
    try {
      const { data } = await API.get("Config/TypeStatus/FaxDirection");
      if (data) {
        setState({
          directionOptions: data,
          loading: false,
        });
      } else {
        setState({ loading: false });
      }
    } catch (error) {
      setState({ loading: false });
    }
  };

  const fetchFaxStatus = async () => {
    try {
      const { data } = await API.get("Config/TypeStatus/FaxStatus");
      if (data) {
        setState({
          faxStatusOption: data,
          loading: false,
        });
      } else {
        setState({ loading: false });
      }
    } catch (error) {
      setState({ loading: false });
    }
  };

  const handleCoverdEntityChange = async (value, setFieldValue, entity) => {
    window.selectedCoveredEntittyId = value;
    handleUpdateEntity(entity);
    setFieldValue("coveredEntityName", value);
    setState({
      selectedCoveredEntity: entity,
      selectedProvider: null,
      selectedPatient: null,
    });

    setSelectedCE(value);
    if (selectedCEId) {
      setFieldValue("direction", direction);
      setState({ direction: direction });
      let param = {};
      param.coveredEntityName = value.toString();
      param.direction = direction;
      if (selectedCEId) {
        setError(false)
      }
      await handleSubmit(param);
    }

  };

  const handleSubmit = async (val) => {
    //const { setSubmitting } = actions;
    const { selectedProvider, selectedPatient, faxstatus } = state;
    const values = cloneDeep(val);
    values.providerNPI = selectedProvider?.id;
    values.patientID = selectedPatient?.id;
    values.faxstatus = faxstatus;


    if (selectedCE == "") {
      setError(true)
      return;
    }
    else {
      setError(false)
    }
    await onSearch(values);
    //setSubmitting(false);
  };

  const handleBoundChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("direction", value);
    setState({ direction: value });
    window.selectedFaxDirection = value;
  };

  const handleFaxStatusChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("faxstatus", value);
    setState({ faxstatus: value });
    window.selectedFaxStatus = value;
  };

  const handleReset = () => {
    const { resetForm } = formikRef.current;
    resetForm();
    onReset();
    setState({
      selectedCoveredEntity: {},
      selectedProvider: null,
      selectedPatient: null,
      direction: "",
      faxstatus: "",
    });
    setSelectedCE("");
    window.selectedCoveredEntittyId = "";
    window.selectedFaxDirection = "";
    window.selectedFaxStatus = "";
    setError(false);
  };

  const onSelectProvider = (provider) => {
    if (provider) {
      setState({ selectedProvider: provider });
    } else {
      setState({ selectedProvider: null });
    }
  };

  const onSelectPatient = (patient) => {
    if (patient) {
      setState({ selectedPatient: patient });
    } else {
      setState({ selectedPatient: null });
    }
  };

  const {
    direction,
    directionOptions,
    faxstatus,
    faxStatusOption,
    selectedCoveredEntity,
    selectedProvider,
    selectedPatient,
  } = state;

  return (
    <Formik
      innerRef={formikRef}
      initialValues={filterBySearch}
      onSubmit={handleSubmit}
      // validationSchema={validationSchema}
      children={(props) => {
        const { isSubmitting, handleSubmit, setFieldValue } = props;
        return (
          <div>
            <h5 className="f-16 text-primary font-weight-700">Search Fax</h5>
            <Row>
              <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="coveredEntityID">Covered Entity</Label>
                  <CoveredEntity
                    value={selectedCE}
                    name="coveredEntityName"
                    orgId={orgId}
                    onChange={(value, enty) =>
                      handleCoverdEntityChange(value, setFieldValue, enty)
                    }
                  />
                  {error == true ? (
                    <div className="text-danger f-12 position-absolute">
                      {"Please select Covered Entity"}
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="direction">Direction</Label>
                  <Field
                    name="direction"
                    type="text"
                    value={direction}
                    onChange={(e) => handleBoundChange(e, setFieldValue)}
                    component={FormikSelectField}
                    options={directionOptions}
                    defaultoption="--Select--"
                    keys={{
                      id: "id",
                      label: "description",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="faxstatus">Fax Status</Label>
                  <Field
                    name="faxstatus"
                    type="text"
                    value={faxstatus}
                    onChange={(e) => handleFaxStatusChange(e, setFieldValue)}
                    component={FormikSelectField}
                    options={faxStatusOption}
                    defaultoption="--Select--"
                    keys={{
                      id: "id",
                      label: "description",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Patient Name</Label>
                  <PatientList
                    tenantID={selectedCoveredEntity.tenantID}
                    onSelect={onSelectPatient}
                    selectedPatient={selectedPatient}
                  />
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup>
                  <Label>NPI/Provider Name</Label>
                  <NPIProviderList
                    tenantID={selectedCoveredEntity.tenantID}
                    onSelect={onSelectProvider}
                    selectedProvider={selectedProvider}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row
              style={{
                justifyContent: "flex-end",
                // marginRight: "10px",
              }}
            >
              <Col md="auto" className="">
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"
                >
                  <span className="right_5">
                    <img src={search} alt="" />
                  </span>{" "} Search
                </Button>
                <Button color="primary" onClick={() => handleReset(props)} className="reset ms-2">
                  <span className="right_5">
                    <img src={reseticon} alt="" />
                  </span>{" "} Reset
                </Button>
              </Col>
            </Row>

          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchContainer;
